export default "__VITE_ASSET__CspZXNKF__"